import React, { useEffect, useState } from "react";
import FilterModal from "../../../components/filter/Modal";
import functions from "../../../util/functions";
import Loading from "../../../components/loading";
import MovFormaPgto from "./mov-forma-pgto";
import MovPeriodo from "./mov-periodo";
import MovimentacaoCaixaAnalitico from "./mov-analitico";
import reqContaEntrada from "../../../services/reqMultiTenant/reqContaEntrada";
import reqContaSaida from "../../../services/reqMultiTenant/reqContaSaida";
import reqCaixa from "../../../services/reqMultiTenant/reqCaixa";
import { ToastContainer } from "react-toastify";
import Notification from "../../../components/toast";
import HeaderReport from "../../../components/header/report";
import HeaderListFilter from "../../../components/header/report-filter";

function MovimentacaoCaixa() {
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [dtini, setDtIni] = useState();
	const [dtfim, setDtFim] = useState();
	const [hrIni, setHrIni] = useState("00:00:00");
	const [hrFim, setHrFim] = useState("23:59:59");
	const [idCaixaOuColaborador, setIdCaixaOuColaborador] = useState("%");
	const [nomeColaboradorOuCaixa, setNomeOuColaborador] = useState("TODOS");
	const [isSelectCaixa, setIsSelectCaixa] = useState(true);
	const [loading, setLoading] = useState(false);

	const [listContaEntrada, setListContaEntrada] = useState([]);
	const [listContaSaida, setListContaSaida] = useState([]);
	const [listEntregas, setEntregas] = useState([]);
	const [listFormasPagto, setListFormasPagto] = useState([]);
	const [listSangriaESuprimento, setListSangriaESuprimento] = useState([]);
	const [recordCount, setRecordCount] = useState("");
	const [hasSearched, setHasSearched] = useState(false);

	useEffect(() => {
		const agora = new Date();
		const dataFormatada = functions.dateToStrIso(agora);
		setDtIni(dataFormatada);
		setDtFim(dataFormatada);
	}, []);

	function openFilter() {
		setIsFilterOpen(!isFilterOpen);
	}

	function closeFilter() {
		setIsFilterOpen(false);
	}

	const listarReceivePayments = () => {
		let dataini = functions.dateByString(dtini);
		let datafim = functions.dateByString(dtfim);

		dataini = dataini + " " + hrIni;
		datafim = datafim + " " + hrFim;

		setIsFilterOpen(!isFilterOpen);

		const tipo = isSelectCaixa ? "caixa" : "colaborador";
		const valorTipo = idCaixaOuColaborador;

		ListarContaEntrada(dataini, datafim, valorTipo, tipo);
	};

	const ListarContaEntrada = async (dataIni, dataFim, valortipo, tipo) => {
		try {
			setLoading(true);

			const [responseContaEntrada, responseContaSaida, responseEntregas, responseSangriaESuprimento] =
				await Promise.all([
					reqContaEntrada.listMovement(tipo, valortipo, dataIni, dataFim),
					reqContaSaida.listMovement(tipo, valortipo, dataIni, dataFim),
					reqContaEntrada.listCalcDelivery(tipo, valortipo, dataIni, dataFim),
					reqCaixa.listSangriaSuprimento(tipo, valortipo, dataIni, dataFim),
				]);

			setRecordCount(responseContaEntrada.data.length);
			setListContaEntrada(responseContaEntrada.data);
			setListContaSaida(responseContaSaida.data);
			setEntregas(responseEntregas.data);
			// setListFormasPagto(responseFormasPgto.data);
			setListSangriaESuprimento(responseSangriaESuprimento.data);
			setHasSearched(true);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "error" });
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="mt-page">
			<ToastContainer />
			<FilterModal //
				title="Movimentação do Caixa"
				isOpen={isFilterOpen}
				onRequestClose={closeFilter}
				filterName={false}
				filterLate={false}
				dataEHora={true}
				dtini={dtini}
				dtfim={dtfim}
				hrIni={hrIni}
				hrFim={hrFim}
				idCaixaOuColaborador={idCaixaOuColaborador}
				isSelectCaixa={isSelectCaixa}
				setHrIni={setHrIni}
				setHrFim={setHrFim}
				setDtIni={setDtIni}
				setDtFim={setDtFim}
				setIdCaixaOuColaborador={setIdCaixaOuColaborador}
				setIsSelectCaixa={setIsSelectCaixa}
				handleList={listarReceivePayments}
				setNomeOuColaborador={setNomeOuColaborador}
				hideToggle={true}
			/>

			{/* HEADER PADRONIZADO */}
			<header className="flex flex-col bg-white p-2 rounded-sm box-shadow-md mb-6">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title="MOVIMENTAÇÃO DO CAIXA" subTitle={nomeColaboradorOuCaixa} />
					</div>
					<div className="col-span-1 flex justify-end mb-2">
						<div className="flex flex-col gap-1">
							<HeaderListFilter
								filterData={{
									origem: {
										label: "Pesquisar por",
										value: "Número do caixa",
									},
									periodo: {
										label: "Período",
										value: `${functions.dateByString(dtini)} ${hrIni} à ${functions.dateByString(dtfim)} ${hrFim}`,
									},
									registros: {
										label: "Registros encontrados",
										value: recordCount || "0",
									},
								}}
							/>
						</div>
					</div>
				</div>

				<div className="col-span-1 flex justify-end items-end mt-2">
					<div className="flex gap-2 h-8">
						<button className="btn btn-sm btn-primary w-32" onClick={openFilter}>
							Filtrar
						</button>
					</div>
				</div>
				<div className="border-bottom mt-3"></div>
			</header>

			{loading ? (
				<Loading />
			) : (
				<>
					{listContaEntrada.length > 0 ? (
						<>
							<MovFormaPgto listContaEntrada={listContaEntrada} />
							<MovPeriodo
								listContaEntrada={listContaEntrada}
								listContaSaida={listContaSaida}
								listSangriaESuprimento={listSangriaESuprimento}
							/>
						</>
					) : (
						hasSearched && (
							<p className="text-sm italic text-gray-400 mt-6 mb-2">Nenhum registro encontrado.</p>
						)
					)}
				</>
			)}

			{/* Divisor visual entre os dois componentes */}
			<div className="flex items-center gap-3 mt-8 mb-2">
				<div className="flex-1 border-t border-slate-200" />
				{/* <span className="text-xs text-slate-400 uppercase tracking-widest whitespace-nowrap">
					Movimentação Analítica
				</span> */}
				<div className="flex-1 border-t border-slate-200" />
			</div>

			{/* <MovimentacaoCaixaAnalitico /> */}
		</div>
	);
}

export default MovimentacaoCaixa;
